import { Auth } from 'aws-amplify';

import * as constants from '@config/constants';
import analytics from '@src/analytics';
// import urls from '@src/urls';

export const checkUser = () => {
  const xhrKey = constants.XHR_USERCHECK;
  return dispatch => {
    const checkAsyncUser = async () => {
      dispatch({ type: constants.XHR_IN_PROGRESS, key: xhrKey });

      try {
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
        const session = await Auth.currentSession();
        if (user && session) {
          console.log({ user, session });
           dispatch({ type: constants.SIGN_IN, data: user });
           // analytics.login(user.username);
        }
      } catch (err) {
        // User is unauthenticated
        console.error('User is unauthenticated.')
        console.log(err);
        // window.location.href = urls.unauthed.login();
      }
      dispatch({ type: constants.XHR_COMPLETE, key: xhrKey });
    };
    checkAsyncUser();
  };
};
